import React, { useState, useEffect,useMemo,useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../../../Template/Sidebar/Sidebar';
import Header from '../../../../Template/Header/Header';
import {baseUrl} from '../../../../../config';
import DatePicker from "react-datepicker";
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";
import {formatNumberWithToFixed} from '../commanFn';
import {clickColor,inArray} from './../../../../../library/util';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import Typography from "@material-ui/core/Typography";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import './../../css/profit.css';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import axiosIntance from '../../../../../helper/axios';
const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }




function ByCampaignID() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const ReportTile='Profits Diagnosis - Summary - By Campaign ID';
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
    const [productCategory,setProductCategory]=useState('');
    const [productCategoryArray,setProductCategoryArray] = useState([]);
    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [C1,setC1]=useState('');
    const [C1Array,setC1Array]=useState([]);
    const [group,setgroup]=useState('');
    const [groupArray,setgroupArray]=useState([]);
    const [checkrvcb,setcheckrvcb]=useState(false);
    const [rvcb,setrvcb]=useState('');
    const selectInputRef = useRef();
    const checkboxRef = useRef();
    const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }

    const loadGroupFn = (inputValue) =>
  new Promise((resolve) => {
    console.log('Input='+inputValue);
    axiosIntance.get(baseUrl+'/reports/profitabilityDiagnosis/group?type=campaign', {}).then(response => {
       resolve(response.data.result.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
       ));
  
    });
  });
  const handleChange=( target )=> {
    if(target!=undefined){
      setgroup(target.value);
    }
}
    
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }


      checkUserTypeFn(history);

      function checkUserTypeFn(history){
        const userdata=JSON.parse(localStorage.getItem('userdata'));
        const usertype=userdata.type;
        console.log('in check usertype fn');
        console.log(usertype)
      //   if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user'){
      //     history.push('/');
      //  }
      if(usertype!='owneradmin' && usertype!='superadmin'){
        history.push('/');
      }
      }
   
    // if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
    //   history.push('/');
    // }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    axiosIntance.defaults.timeout = 36000000;//10min
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    // const ResetFilter = () => {
    //   setMessage('')
    //   setEndDate(new Date(Date.now()))
    //   setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    // }
    const ResetFilter = () => { 
      if(checkrvcb==true)
      checkboxRef.current.click();
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
      setgroup('');
      setcheckrvcb(false);
      setrvcb('');
     
      setgroupArray([])
      setReportData([]);
      selectInputRef.current.clearValue();
    }

    
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Start Date must not be blank')
      return false;
    }if(endDate==null){
      setMessage('End Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let groupStr=groupArray.join('*');
    console.log(groupStr);
    var response={};
    response.data={};
    response.data.result=[];
    setLoader(true);
    axiosIntance.get(baseUrl+'/reports/profitabilityDiagnosis/summary?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm')+"&type=campaign&group="+groupStr+"&checkrvcb="+checkrvcb+"&rvcb="+rvcb, {}).then(response => {
  
        if (response.data.result.length > 0) {
          console.log('data we have')
          response.data.result.forEach((i,j)=>{
            try{
          i.aov=roundToTwo(i.aov)
          i.net_profit_margin=roundToTwo(i.net_profit_margin*100)+"%";
          i.revenue="$"+formatNumberWithToFixed(i.revenue).toLocaleString();
          i.aov="$"+formatNumberWithToFixed(i.aov).toLocaleString();
          i.cpa_per_fe="$"+formatNumberWithToFixed(i.cpa_per_fe).toLocaleString();
          i.total_cogs_per_cart="$"+formatNumberWithToFixed(i.total_cogs_per_cart).toLocaleString();
          i.shipping_per_cart="$"+formatNumberWithToFixed(i.shipping_per_cart).toLocaleString();
          i.handling_per_cart="$"+formatNumberWithToFixed(i.handling_per_cart).toLocaleString();
          i.cs_cost_per_cart="$"+formatNumberWithToFixed(i.cs_cost_per_cart).toLocaleString();
          i.r_v_cb_per_cart="$"+formatNumberWithToFixed(i.r_v_cb_per_cart).toLocaleString();
          i.total_processing_per_cart="$"+formatNumberWithToFixed(i.total_processing_per_cart).toLocaleString();
          i.profit_per_cart="$"+formatNumberWithToFixed(i.profit_per_cart).toLocaleString();
          i.total_net_profit="$"+formatNumberWithToFixed(i.total_net_profit).toLocaleString();
            }catch(e){
              console.log(e);
            }
          });
          setReportData(response.data.result);
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{

    let groupStr=groupArray.join('*');
    const token = window.localStorage.getItem('token');
    window.location.href=baseUrl+'/reports/profitabilityDiagnosis/summary/download?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm')+"&type=campaign&group="+groupStr+"&checkrvcb="+checkrvcb+"&rvcb="+rvcb+"&token="+token;
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(group);
    if(group!=''){
      if(inArrayForString(group,groupArray)==false){ 
      setgroupArray(oldArray => [...oldArray,group] );
      setgroup('');
      }
    }
    selectInputRef.current.clearValue();
    console.log('Group')
    console.log(group);
    console.log(groupArray);
   
      //setProductCategoryStr();
    }
   
  

    const deleteGroupFn = (item,index) =>{
      console.log(item);
      removeItemOnce(groupArray,item);
      console.log(groupArray);
  
      let temp = groupArray.filter((category) => category !== item);
      console.log(temp);
      setgroupArray(temp);
    }
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <label>Start Date</label>
    <label className='endDateStyle'>End Date</label>
    <label className='groupStyle'>Group</label>
  
    
    <div className="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

  
    <div className="input-bar-item width100">
    
    {/* <input 
    type="text" 
     name='group'
     className='width140x'
     value={group}
     placeholder="Group"
     onChange={e => setgroup(e.target.value)} 
     
      /> */}

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChange(e)} 
        cacheOptions
        defaultOptions
        maxMenuHeight={250} 
        className="widthSelectInput"
        classNamePrefix="select"
         styles={colourStyles}
        getOptionLabel={(e) => e.value}
        getOptionValue={(e) => e.value}
        loadOptions={loadGroupFn}        
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

    
<div className="checkboxDiv">
<FormGroup>
  <FormControlLabel control={<Checkbox  
   ref={checkboxRef}  
  sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }}
  name='Estimate Ref+V+CB'
  value={checkrvcb}
  defaultChecked={checkrvcb}
  onChange={() => setcheckrvcb(!checkrvcb)}
  />} 
  label="Estimate R+V+CB" />
</FormGroup>
</div>

{!checkrvcb ?  '' :
    
      
    <div className="input-bar-item">
    
    <input 
    pattern="[0-9.]+" type="number"
     name='rvcb'
     className='width92x'
     value={rvcb}
     placeholder="R+V+CB"
     onChange={e => setrvcb(e.target.value)} 
     
      />
      

    </div>
    }
    &nbsp;&nbsp;
  


    <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div className='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}
      <div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>

  <div className="FilterSection">
  
  {groupArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">Group = {item}{ }</span>
       <span  onClick={(event) => deleteGroupFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}




    
  </div>
 

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={
              [
                {
                  title: "Group",
                  field: "reportby",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Name.of.Group",
                  field: "groupname",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Frontend",
                  field: "front_end_count",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Total.Revenue",
                  field: "revenue",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "AOV",
                  field: "aov",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "CPA.per.FE",
                  field: "cpa_per_fe",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Total.COGS.per.Cart",
                  field: "total_cogs_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Shipping.per.Cart",
                  field: "shipping_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Handling.per.Cart",
                  field: "handling_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "R+V+CB.per.Cart",
                  field: "r_v_cb_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Total.Processing.per.Cart",
                  field: "total_processing_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "CS.COST.per.Cart",
                  field: "cs_cost_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    if(rowdata.last==1){
                      return{
                        fontWeight: 'bold'
                      }
                    }
                  }
                },
                {
                  title: "Profit.per.Cart",
                  field: "profit_per_cart",
                  cellStyle: (e,
                  rowdata)=>{
                    return{
                      fontWeight: 'bold'
                    }
                  }
                },
                {
                  title: "Net.Profit.Margin",
                  field: "net_profit_margin",
                  cellStyle: (e,
                  rowdata)=>{
                    return{
                      fontWeight: 'bold'
                    }
                  }
                },
                {
                  title: "Total.Net.Profit",
                  field: "total_net_profit",
                  cellStyle: (e,
                  rowdata)=>{
                    return{
                      fontWeight: 'bold'
                    }
                  }
                },
                
              ]
            }
            data={
                reportData
            }
             title={ReportTile}
          
            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize:10,
              loadingType: 'overlay',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })
              }}
              // components={{
              //   OverlayLoading: props => (<div>Heye</div>)
              // }}
          />
        }
        </section>
       
      </div>

    )
}

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

export default ByCampaignID
